<template>
    <v-container grid-list-xl fluid>
        <v-row class="mb-2 mb-md-1 mb-lg-2 text-center">
            <v-col cols="12" sm="12">
                <h3 class="text-h6 text-md-h5 text-lg-h3 mt-1 mt-md-1 mt-lg-2">
                    {{ convocatoria.cite }}
                </h3>
                <p class="text-subtitle-1 text-md-h5 text-lg-h4 mt-1 mt-md-1 mt-lg-2">
                    {{ convocatoria.descripcion }}
                </p>
            </v-col>

        </v-row>

        <v-row justify="center">
            <v-col cols="12" sm="8" class="d-flex justify-center">
                <v-img src="../assets/bannerIngles.jpeg" class="logo" />
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="4">
                <v-card>
                    <v-card-text class="grey--text text--darken-4">
                        <v-card class="mt-3" color="#B2EBF2" tile>
                            <v-card-title class="teal--text text--darken-4 text-h6">
                                Convocatoria
                            </v-card-title>
                            <v-card-subtitle class="grey--text text--darken-3">
                                Presione el boton <b>DESCARGAR</b> para ver la convocatoria.
                            </v-card-subtitle>
                            <v-card-actions>
                                <v-btn color="#546E7A" outlined
                                    href="//api.dgesu.minedu.gob.bo/normativas/Ingles_para_todos_Convocatoria_2026.pdf"
                                    target="_blank" download>
                                    Descargar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4">
                <v-card>
                    <v-card-text class="grey--text text--darken-4">
                        <v-card class="mt-3" color="#F0F4C3" tile>
                            <v-card-title class="teal--text text--darken-4 text-h6">
                                Reglamento
                            </v-card-title>
                            <v-card-subtitle class="grey--text text--darken-3">
                                Presione el boton <b>DESCARGAR</b> para ver el reglamento.
                            </v-card-subtitle>
                            <v-card-actions>
                                <v-btn color="#546E7A" outlined
                                    href="//api.dgesu.minedu.gob.bo/normativas/Ingles_para_todos_Reglamento_2026.pdf"
                                    target="_blank" download>
                                    Descargar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4">
                <v-card>
                    <v-card-text class="grey--text text--darken-4">
                        <v-card class="mt-3" color="#BBF0C8" tile>
                            <v-card-title class="teal--text text--darken-4 text-h6">
                                Postulación
                            </v-card-title>
                            <v-card-subtitle class="grey--text text--darken-3">
                                Presione el boton <b>INGRESAR</b> para postular a la convocatoria.
                            </v-card-subtitle>
                            <v-card-actions>
                                <v-btn color="#546E7A" outlined
                                    :to="{ path: '/admision/inscripcion' }">
                                    Ingresar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <br />
        <hr />
        <br />


        <!-- <v-row>

            <v-col offset-sm="4" cols="12" sm="4">
                <v-card>
                    <v-card-title>Nota importante</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <p>
                            Para usar el sistema se recomienda utilizar los siguientes
                            navegadores web, a razón del uso de las nuevas tecnologías.
                        </p>
                        <p>Navegadores:</p>
                        <div class="pl-5">
                            <a href="https://www.google.com/intl/es/chrome/" target="_blank">
                                <b>Chrome</b> en su ultima preferentemente
                            </a>
                            <br />
                            <a href="https://www.mozilla.org/es-ES/firefox/new/" target="_blank">
                                <b>Firefox</b> en su ultima preferentemente
                            </a>
                            <br />
                            <a href="https://www.opera.com/es" target="_blank">
                                <b>Opera</b> en su ultima preferentemente
                            </a>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
    </v-container>
</template>

<script>
// import Service from "../utils/general";
import Service from "../services/request";
export default {
    name: "inicio",
    data: () => ({
        message: "",
        loading: false,
        convocatoria: {
            id: 0,
            cite: "",
            descripcion: "",
            gestion: "",
        },
        cite: ""
    }),
    mounted() { },
    created() {
        this.getAnnouncement();
    },
    methods: {
        getAnnouncement() {
            this.notify_load = true;
            Service.svcAdmissionAnnouncement()
                .then((response) => {
                    this.convocatoria = response.data;
                    this.convocatoria.cite = this.convocatoria.cite.toUpperCase();
                    this.convocatoria.descripcion = this.convocatoria.descripcion.toUpperCase() + ' GESTIÓN ' + this.convocatoria.gestion;
                    this.notify_title = "Notificación";
                    this.notify_load = false;
                })
                .catch(() => {
                    this.notify_title = "Notificación";
                    this.notify_load = false;
                });
        },
    },
};
</script>